import React from 'react';

import { Box, Tooltip } from '@mui/material';

import { Icon, IconSize, IconName } from '../icon';

interface IconTooltipCellProps {
  value: React.ReactNode;
  tooltipItems?: React.ReactNode[];
  showTooltip?: boolean;
  iconName?: IconName;
  iconSizeVariant?: IconSize;
  iconColor?: string;
}

export const IconTooltipCell = ({
  value,
  tooltipItems = [],
  showTooltip = true,
  iconName = 'AlertSVG',
  iconSizeVariant = 'xSmall',
  iconColor,
}: IconTooltipCellProps) => {
  const shouldShow = showTooltip && tooltipItems.length > 0;

  return (
    <Box display="flex" alignItems="center" columnGap={1}>
      <span>{value}</span>

      {shouldShow && (
        <Tooltip
          arrow
          title={
            <Box>
              {tooltipItems.map((item, index) => (
                <Box key={index}>{item}</Box>
              ))}
            </Box>
          }
        >
          <Box
            component="span"
            sx={{
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon
              name={iconName}
              sizeVariant={iconSizeVariant}
              color={iconColor}
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
